import { bind } from "file-loader";
import store from "../store";
export default {
  loadmore: {
    bind(el, binding) {
      const selectDom = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      selectDom.addEventListener("scroll", function() {
        const isEnd = this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (isEnd) {
          binding.value();
        }
      });
    }
  },
  btnHas: {
    inserted(el, binding) {
      if (!store.getters.btns.includes(binding.value)) {
        el.parentNode.removeChild(el);
      }
    }
  },
  keyEnter: {
    bind(el, binding, vnode) {},
    inserted(el, binding) {
      document.onkeydown = function(e) {
        let key = window.event.keyCode;
        if (key == 13) {
          binding.value();
        }
      };
    },
    unbind() {
      document.onkeydown = null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/directives/index.js